import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { CopyableCode } from '@/components/shared/copyableCode';
import { getByovSetupScript } from './byovSetupScript';
import { VaultOwnBucketCopyableAllAccountsPolicy } from './vaultOwnBucketCopyablePolicy';
export const ByovSetupScriptPanel = t0 => {
  const $ = _c(14);
  const {
    bucketName,
    region,
    accountId
  } = t0;
  if (!bucketName || !region || !/^\d{12}$/.test(accountId)) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Typography variant="body1">Select a bucket and vault account to generate the script.</Typography>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "16px"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== accountId) {
    t2 = <Typography variant="body1">Requires AWS CLI v2, jq, and AWS credentials for account{" "}<strong>{accountId}</strong>.</Typography>;
    $[2] = accountId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== accountId || $[5] !== bucketName || $[6] !== region) {
    t3 = policy => {
      const script = getByovSetupScript(bucketName, region, accountId, policy);
      return <CopyableCode title="eon-bucket-setup.sh" code={script} maxHeight="320px" />;
    };
    $[4] = accountId;
    $[5] = bucketName;
    $[6] = region;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== bucketName || $[9] !== t3) {
    t4 = <VaultOwnBucketCopyableAllAccountsPolicy bucketName={bucketName} renderCode={t3} />;
    $[8] = bucketName;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <Stack sx={t1}>{t2}{t4}</Stack>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};